import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { Toaster } from "sonner";
import { SiteContentProvider } from "./hooks/useSiteContent";
import Nav from "./components/site/Nav";
import Hero from "./components/site/Hero";
import Marquee from "./components/site/Marquee";
import Credentials from "./components/site/Credentials";
import Stats from "./components/site/Stats";
import HowItWorks from "./components/site/HowItWorks";
import Benefits from "./components/site/Benefits";
import Profitability from "./components/site/Profitability";
import EbookSection from "./components/site/EbookSection";
import AboutMe from "./components/site/AboutMe";
import VideoSection from "./components/site/VideoSection";
import Testimonials from "./components/site/Testimonials";
import InvestorProfile from "./components/site/InvestorProfile";
import FAQ from "./components/site/FAQ";
import ContactForm from "./components/site/ContactForm";
import Footer from "./components/site/Footer";
import WhatsAppButton from "./components/site/WhatsAppButton";
import ExitPopup from "./components/site/ExitPopup";
import QuizCompletionBanner from "./components/site/QuizCompletionBanner";
import ExpointerSurvey from "./components/site/ExpointerSurvey";
import PartnerCapture from "./components/site/PartnerCapture";
import AdminPanel from "./components/admin/AdminPanel";
import RegulamentoSorteio from "./components/site/RegulamentoSorteio";
import { useUTMs } from "./hooks/useUTMs";
import HomeV2 from "./components/v2/HomeV2";

function HomeWrapper() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isV2 = searchParams.get("lp") === "v2";

  return isV2 ? <HomeV2 /> : <Home />;
}

// Captura UTMs da URL em qualquer rota e persiste no sessionStorage
function UTMCapture() {
  useUTMs();
  return null;
}

function Home() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Nav />
      <Hero />
      <Marquee />
      <AboutMe />
      <Credentials />
      <Stats />
      <HowItWorks />
      <Benefits />
      <VideoSection />
      <Profitability />
      <EbookSection />
      <Testimonials />
      <InvestorProfile />
      <FAQ />
      <ContactForm />
      <Footer />
      <WhatsAppButton />
      <ExitPopup />
      <QuizCompletionBanner />
    </div>
  );
}

function App() {
  return (
    <MotionConfig reducedMotion="user">
    <SiteContentProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-center" richColors />
        <UTMCapture />
        <Routes>
          <Route path="/" element={<HomeWrapper />} />
          <Route path="/expointer" element={<ExpointerSurvey />} />
          <Route path="/parceiro/:slug" element={<PartnerCapture />} />
          <Route path="/regulamento" element={<RegulamentoSorteio />} />
          <Route path="/admin" element={<AdminPanel />} />
        </Routes>
      </BrowserRouter>
    </SiteContentProvider>
    </MotionConfig>
  );
}

export default App;

